export const setCookie = function(name, value, expiresInDays, path, domain) {
	let cookie;
	
	cookie = `${name}=${value};`;
	
	if (expiresInDays) {
		const expires = new Date(Date.now() + parseInt(expiresInDays) * 1000 * 60 * 60 * 24);
		cookie += `expires=${expires.toGMTString()};`;
	}

	if (path) {
		cookie += `path=${path};`;
	}

	if (domain) {
		cookie += `domain=${domain};`;
	}

	document.cookie = cookie;
};

export const cookieExist = function(name) {
	return document.cookie.indexOf(`${name}=`) !== -1;
};

export const getCookieValue = function(name) {
	const cookieList = document.cookie.split(';');
	const namePlusEqual = `${name}=`;

	const cookieFound = cookieList.find((el) => el.includes(namePlusEqual));

	if (cookieFound) {
		return cookieFound.substring(cookieFound.indexOf('=') + 1);
	} else {
		return null;
	}
};

